<template>
  <md-dialog
      class="upload-tips-dialog"
      :closable="false"
      :has-mask="false"
      v-model="showDialog"
  >
    <div class="wrapper">
      <template v-if="uploadTipsType === 'loading'">
        <img class="gif" src="./assets/loading.gif" />
        <div class="bg"></div>
        <div class="text">
          <div>后台正在火速上传中</div>
          <div>请耐心等待…</div>
        </div>
      </template>

      <template v-if="uploadTipsType === 'success'">
        <div class="bg-success">
          <img src="./assets/success.png" />
          <span>上传成功</span>
        </div>
      </template>
    </div>
  </md-dialog>
</template>

<script>
import { Dialog } from 'mand-mobile';

export default {
  name: 'UploadTips',
  components: {
    [Dialog.name]: Dialog
  },
  data () {
    return {
      showDialog: false
    };
  },
  watch: {
    isShowUploadTips (val) {
      this.showDialog = val;
      if (!val) {
        setTimeout(() => {
          this.setUploadTipsType('loading');
        }, 500);
      }
    }
  },
  computed: {
    ...mapState('publicStore', ['isShowUploadTips', 'uploadTipsType'])
  },
  methods: {
    ...mapMutations('publicStore', ['setUploadTipsType'])
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  position: relative;
  width: 224px;
  height: 224px;

  .gif {
    width: 224px;
    height: 224px;
  }

  .bg {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 30px;
    z-index: -1;
    width: 200px;
    height: 172px;
    background: #444444CC;
    backdrop-filter: blur(4px);
    border-radius: 10px;
  }

  .text {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 46px;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: -0.33px;
    text-align: center;
    color: #FFF;
  }

  .bg-success {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 172px;
    background: #444444CC;
    backdrop-filter: blur(4px);
    border-radius: 10px;

    img {
      position: absolute;
      top: 26px;
      left: 50%;
      transform: translateX(-50%);
      width: 72px;
      height: 72px;
    }

    span {
      position: absolute;
      bottom: 26px;
      left: 50%;
      transform: translateX(-50%);
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: -0.33px;
      text-align: center;
      color: #FFF;
    }
  }
}
</style>

<style lang="scss">
.upload-tips-dialog {
  .md-popup {
    z-index: 99999999999999!important;
  }
  .md-dialog-content {
    background-color: transparent;
    width: unset!important;

    .md-dialog-actions {
      display: none;
    }
  }
}
</style>
